import React from 'react';
import { COLORS } from '../../styles/tokens';

const DEFAULT_MSG = 'Tippi er midlertidig utilgjengelig. Prøv igjen om litt.';

export default function MaintenancePage({ message }) {
  return (
    <div style={{
      height: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: COLORS.bg, padding: 24, textAlign: 'center',
    }}>
      <div style={{ fontSize: 48, marginBottom: 24 }}>🔧</div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: COLORS.textDark, marginBottom: 12 }}>
        Under vedlikehold
      </h1>
      <p style={{ fontSize: 15, color: COLORS.textMid, maxWidth: 360, lineHeight: 1.6, marginBottom: 32 }}>
        {message || DEFAULT_MSG}
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '12px 28px', borderRadius: 8, border: 'none',
          background: COLORS.primary, color: COLORS.onPrimary, fontSize: 15,
          fontWeight: 600, cursor: 'pointer',
        }}
      >
        Prøv igjen
      </button>
    </div>
  );
}
